<template>
  
  <div :id="_uid" class="ui search" :class="{ fluid }">
    <div class="ui icon input" :class="{ 'disabled loading': loading }">
      <input :id="_uid + '_input'" class="prompt" type="text" :placeholder="placeholder" @blur="onInputBlur()">
      <i v-if="pickedObj" class="check blue icon animated fadeIn"></i>
      <i v-else class="search icon animated fadeIn"></i>
    </div>
    <div class="results"></div>
  </div>   

</template>

<script>

  export default {

    data() {
      return {
        loading: true,
        token: "",
        pickedObj: null,
      }
    },

    props: {
      authToken: { type: String },
      fluid: { type: Boolean, default: true },
      path: { type: String, required: true },
      query: { type: String },
      attributes: { type: String, required: true },
      renderTitle: { type: Function, required: true },
      renderDescription: { type: Function },
      renderLabel: { type: Function },
      placeholder: { type: String, default: "Pesquisar..." },
      maxResults: { type: Number, default: 15 },
      checkItem: { type: Function },      
    },
    
    mounted() {
      this.initSearch()      
    },

    methods: {      

      async initSearch() {  

        this.loading = true
        
        try {

          this.token = this.authToken || await this.$store.state.auth.fbUser.getIdToken(true)

          let url = process.env.VUE_APP_API_URL + `/${this.path}?search={query}`

          if (this.attributes != "*")
            url += `&attributes=${this.attributes}`

          if (this.query)
            url += `&${this.query}`  
          
          $(`#${this._uid}`).search({
            minCharacters: 3,
            maxResults: this.maxResults,
            apiSettings: {
              url,
              beforeXHR: this.beforeXHR,
              onResponse: this.onResponse,    
              onError: this.onError,        
            },
            onSearchQuery: this.onClear,
            onSelect: this.onSelect,
            templates: {
              message: () => '<div class="grey text p-10"><i class="info circle icon"></i> Nenhum registro encontrado</div>'
            },
          })
          
        } catch (error) {

          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      beforeXHR(xhr) {
        
        xhr.setRequestHeader("auth-token", this.token)

        return xhr      
      },

      onResponse(data) {

        let results = []
        let obj = null
        let item = null

        for (let key in data) {

          obj = data[key]
          item = { value: obj, title: this.renderTitle(obj) }

          if (this.renderDescription)
            item.description = this.renderDescription(obj)    

          if (this.checkItem && !this.checkItem(item))
            continue  

          results.push(item)
        }  

        return { results }
      },

      onError(errorMessage, element, xhr) {
        
        console.log({ errorMessage, element, xhr })

        this.$msg.error("Falha ao pesquisar registros")
      },

      onInputBlur() {
        if (!this.pickedObj)
          this.clear()
      },

      onClear() {
        this.pickedObj = null
        this.$emit("onClear")
      },

      onSelect(result) {     
        this.setSelected(result.value) 
        this.$emit("onPick", result.value)
      },

      clear() {
        $(`#${this._uid}`).search("set value", "")
        this.pickedObj = null
      },

      setSelected(obj) {        

        let label = this.renderLabel ? this.renderLabel(obj) : this.renderTitle(obj)
        
        $(`#${this._uid}`).search("set value", label)

        this.pickedObj = this.$cloneObject(obj)
      },
    },
  }

</script>